
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';
import HeroSection from '@/components/social-media/HeroSection';
import WhyKIVideos from '@/components/social-media/WhyKIVideos';
import ExampleGallery from '@/components/social-media/ExampleGallery';
import ProcessSteps from '@/components/social-media/ProcessSteps';
// WhyFutureLevel component removed
import FAQSection from '@/components/social-media/FAQSection';
import CtaSection from '@/components/social-media/CtaSection';
import FloatingCTA from '@/components/social-media/FloatingCTA';

const SocialMediaAdsPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // Update SEO meta tags
    updateMetaTags({
      title: `${t.socialMediaAds} | Future Level`,
      description: t.socialMediaAdsDesc,
      keywords: "Social Media Ads, KI Video Ads, Facebook Ads, Instagram Videos, TikTok Videos, AI Video Marketing",
      canonicalUrl: getCanonicalUrl('services/social-media-ads', currentLanguage),
      language: currentLanguage,
      ogType: "article"
    });
    
    // Add console log to verify the component is rendering
    console.log("SocialMediaAdsPage rendered with ExampleGallery component");
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <WhyKIVideos />
        <ExampleGallery />
        <ProcessSteps />
        {/* WhyFutureLevel component removed from here */}
        <FAQSection />
        <CtaSection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

export default SocialMediaAdsPage;
